export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13218.1d26876f.jpg";